import React from "react";
import { Grid } from "semantic-ui-react";
import { AccordionTitleView } from "../../../components";
import { LcalCulculationDefultValues } from "../../../config/constants";
import SupplierIngredientLcaDataView from "../shared/components/SupplierIngredientLcaDataView";

interface IngredientLcaData {
  acidification: number;
  climateChange: number;
  ecotoxicityFreshWater: number;
  eutrophicationFreshWater: number;
  eutrophicationMarine: number;
  eutrophicationTerrestrial: number;
  humanToxicityCancer: number;
  humanToxicityNonCancer: number;
  ionisingRadiation: number;
  landUse: number;
  ozoneDepletion: number;
  particulateMatter: number;
  photochemicalOzoneFormation: number;
  resourceUseFossils: number;
  resourceUseMineralsAndMetals: number;
  waterUse: number;
}

interface IngredientLcaDetailsProps {
  lcaData?: IngredientLcaData | null;
}

const IngredientLcaDetails: React.FC<IngredientLcaDetailsProps> = ({ lcaData }) => {
  const prettifyLabel = (key: string) =>
    key
      .replace(/-/g, " ")
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/\b\w/g, c => c.toUpperCase());

  return (
    <div>
      <AccordionTitleView accordionEnabled={false} title={""} plusIcon={false} />
      <Grid>
        <Grid.Row divided>
          <Grid.Column computer={8} tablet={16} mobile={16}>
            <Grid columns={4}>
              <Grid.Row>
                {lcaData &&
                  Object.keys(lcaData).map(key => {
                    const value = lcaData[key as keyof IngredientLcaData];
                    return (
                      <Grid.Column key={key}>
                        <p className="textLabel mb-0">{prettifyLabel(key)}</p>
                        <p className="textLabel">{`${value} ${
                          LcalCulculationDefultValues[
                            key as keyof typeof LcalCulculationDefultValues
                          ]?.unit
                        }`}</p>
                      </Grid.Column>
                    );
                  })}
              </Grid.Row>
            </Grid>
          </Grid.Column>
          <Grid.Column computer={8} tablet={16} mobile={16}>
            <SupplierIngredientLcaDataView dataView={true} ingredientId={"11"} supplierId={"22"} />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  );
};

export default IngredientLcaDetails;
